import { AES } from "crypto-js";
import { env } from "./env";

const secret = env.NEXT_PUBLIC_ENCRTYPTION_SECRET;

export function encrypt(value: string) {
  return AES.encrypt(value, secret).toString();
}
